import { installStaticSiteAnalytics } from "./analyticsRuntime/staticSite.gen";
import { siteAnalyticsConfigs } from "./analyticsRuntime/siteConfig.gen";

let tracker: ReturnType<typeof installStaticSiteAnalytics> | undefined;
/** Called by the site's existing browser entry and route lifecycle. */
export function trackSitePage(): void {
  if (typeof window === "undefined") return;
  tracker ??= installStaticSiteAnalytics({
    configs: siteAnalyticsConfigs,
    excludedPrefixes: ["/predictions", "/style-guide", "/vip", "/editions", "/contact"],
    navigation: {"/football-predictions/": "football-predictions"},
  });
  tracker.page();
}
